import axios from 'axios';

const templates = [{
  name : 'Minimalist black & white on top',
  content : '<p style="text-align: center;">This website uses cookies to ensure you get the best experience on our website. <a href="#" rel="noopener" target="_blank"><span style="color: #7e8c8d;">Learn more</span></a></p>',
  config: {"popupBackgroundColor":"#FFFFFF","popupGlassBackground":false,"popupVerticalPosition":"top","popupHorizontalPosition":"right","popupFullWidth":true,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"center","acceptButtonText":"Accept","acceptButtonTextColor":"#FFFFFF","acceptButtonBackgroundColor":"#000000","declineButtonEnabled":false,"declineButtonText":"Decline","declineButtonTextColor":"#000000","declineButtonBackgroundColor":"#FFFFFF"},
  img: 'minimalist-bw-top.jpg'
},
{
  name: 'Elegant black',
  content : '<p style="text-align: left;"><span style="color: #ffffff; font-size: 12pt;">This website uses cookies to ensure you get the best experience on our website. </span></p>\
<p style="text-align: left;"><span style="font-size: 12pt; color: #ffffff;"><strong><em><a href="#" rel="noopener" style="color: #ffffff;" target="_blank">Learn more</a></em></strong></span></p>',
  config : {"popupBackgroundColor":"rgba(6,5,16, 0.85)","acceptButtonTextColor":"rgba(1,4,3, 1)","acceptButtonBackgroundColor":"rgba(255,255,255, 1)","popupGlassBackground":true,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":false,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"left","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"rgba(255,255,255, 1)","declineButtonBackgroundColor":"rgba(0,0,0, 1)","popupShadow":true,"popupRightSpace":"32","popupBottomSpace":"32","popupRoundedCorners":"8","popupTopSpace":0,"popupLeftSpace":0},
  img: 'elegant-black.jpg'
},
{
  name: 'Glassy grey Apple style',
  content : '<p style="text-align: center;"><span style="color: #000000; font-size: 12pt;">This website uses cookies to ensure you get the best experience on our website. </span></p>\
<p style="text-align: center;"><span style="font-size: 12pt; color: #000000;"><strong><em><a href="#" rel="noopener" style="color: #000000;" target="_blank">Learn more</a></em></strong></span></p>',
  config : {"popupBackgroundColor":"rgba(208,207,222, 0.52)","acceptButtonTextColor":"rgba(1,4,3, 1)","acceptButtonBackgroundColor":"rgba(255,255,255, 1)","popupGlassBackground":true,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":true,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"center","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"rgba(5,5,5, 1)","declineButtonBackgroundColor":"rgba(0,0,0, 0)","popupShadow":true,"popupRightSpace":"32","popupBottomSpace":"32","popupRoundedCorners":"8","popupTopSpace":0,"popupLeftSpace":"32"},
  img: 'apple-grey.jpg'
},{
  name : 'Minimalist black & white bottom',
  content : '<p style="text-align: left;">This website uses cookies to ensure you get the best experience on our website. <a href="#" rel="noopener" target="_blank"><span style="color: #7e8c8d;">Learn more</span></a></p>',
  config: {"popupBackgroundColor":"#FFFFFF","acceptButtonTextColor":"#FFFFFF","acceptButtonBackgroundColor":"#000000","popupGlassBackground":false,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":false,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"left","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"#000000","declineButtonBackgroundColor":"#FFFFFF"},
  img: 'minimalist-bw-bottom.jpg'
},{
  name : 'Classical top',
  content : '<p style="text-align: center;">This website uses cookies to ensure you get the best experience on our website. <a href="#" rel="noopener" target="_blank"><span style="color: #7e8c8d;">Learn more</span></a></p>',
  config: {"popupBackgroundColor":"rgba(250,250,250, 1)","acceptButtonTextColor":"#FFFFFF","acceptButtonBackgroundColor":"rgba(0,91,209, 1)","popupGlassBackground":false,"popupVerticalPosition":"top","popupHorizontalPosition":"right","popupFullWidth":true,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"center","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"rgba(0,91,209, 1)","declineButtonBackgroundColor":"#FFFFFF"},
  img: 'classical-top.jpg'
}, {
  name : 'Modern bottom',
  content : '<p style="text-align: right;">This website uses cookies to ensure you get the best experience on our website.</p><p style="text-align: right;"><a href="#" rel="noopener" target="_blank"><span style="color: #7e8c8d;">Learn more</span></a></p>',
  config: {"popupBackgroundColor":"rgba(255,255,255, 0.5)","acceptButtonTextColor":"#FFFFFF","acceptButtonBackgroundColor":"#000000","popupGlassBackground":true,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":false,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"right","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"#000000","declineButtonBackgroundColor":"#FFFFFF"},
  img: 'modern-bottom.jpg'
}, {
  name : 'Eikyo purple',
  content : '<p style="text-align: right;"><span style="color: #ffffff; font-size: 14pt;">This website uses cookies to ensure you get the best experience on our website. </span></p>\
  <p style="text-align: right;"><span style="font-size: 14pt; color: #ffffff;"><strong><em><a href="#" rel="noopener" style="color: #ffffff;" target="_blank">Learn more</a></em></strong></span></p>',
  config: {"popupBackgroundColor":"#5f68d4","acceptButtonTextColor":"#5f68d4","acceptButtonBackgroundColor":"rgba(255,255,255, 1)","popupGlassBackground":false,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":false,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"right","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"#5f68d4","declineButtonBackgroundColor":"rgba(195,199,239, 1)"},
  img: 'eikyo-colored.jpg'
},
{
  name: 'Eikyo green colored',
  content : '<p style="text-align: center;"><span style="color: #ffffff; font-size: 14pt;">This website uses cookies to ensure you get the best experience on our website. </span></p>\
<p style="text-align: center;"><span style="font-size: 14pt; color: #ffffff;"><strong><em><a href="#" rel="noopener" style="color: #ffffff;" target="_blank">Learn more</a></em></strong></span></p>',
  config : {"popupBackgroundColor":"rgba(96,210,182, 0.71)","acceptButtonTextColor":"rgba(95,211,182, 1)","acceptButtonBackgroundColor":"rgba(255,255,255, 1)","popupGlassBackground":true,"popupVerticalPosition":"bottom","popupHorizontalPosition":"right","popupFullWidth":true,"popupWidth":"540","popupWidthUnit":"px","buttonsPosition":"center","acceptButtonText":"Accept","declineButtonEnabled":true,"declineButtonText":"Decline","declineButtonTextColor":"rgba(255,255,255, 1)","declineButtonBackgroundColor":"rgba(111,195,174, 1)"},
  img: 'eikyo-colored-2.jpg'
}
];

export default  {
    namespaced: true,
    state: { 
        namespaced: true,
        domains: [],    
        domain: {},
        domainStats: {},
        status: '',
        creationStatus: '',
        templates: templates
    },
    getters: { 
        domains: state => state.domains,
        status: state => state.status,
    },
    mutations: { 
        DOMAINS_RETRIEVED: (state, domains) => {
            state.status = '';
            if (domains == undefined) {
                state.domains = [];
            } else {
                state.domains = domains;
            }
        },
        DOMAIN_RETRIEVED: (state, resp) => {
          state.status = '';
          if (resp.domain == undefined) {
              state.domain = null;
          } else {
              state.domain = resp.domain;
              if (state.domain.config == '' || state.domain.config == null) {
                state.domain.config = '{}';
              }
              state.domain.config = JSON.parse(state.domain.config);
              state.domainStats = resp.stats;
          }
      },
        DOMAINS_LOADING: (state) => {
            state.status = 'loading'
        },
        DOMAINS_CREATING: (state) => {
            state.creationStatus = 'loading'
        },
        DOMAINS_CREATED: (state) => {
            state.creationStatus = ''
        },
    },
    actions: { 
        USER_DOMAINS: ({commit, state, rootState}) => {
          console.log(rootState.token);
          console.log(rootState.user);
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("DOMAINS_LOADING")
              axios({url: 'https://www.eikyo.pro/api/getDomainsForUser', data: {
                token: rootState.token,
              }, method: 'POST' })
                .then(resp => {
                  commit("DOMAINS_RETRIEVED", resp.data.payload.Table)
                  resolve(resp)
                })
            })
          },
          LOAD_DOMAIN: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("DOMAINS_LOADING")
              axios({url: 'https://www.eikyo.pro/api/campaigns/get', data: {
                token: rootState.token,
                domain: domain 
              }, method: 'POST' })
                .then(resp => {
                  commit("DOMAIN_RETRIEVED", resp.data.payload)
                  resolve(resp)
                })
            })
          },
          CREATE_DOMAIN: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("DOMAINS_CREATING")
              axios({url: 'https://www.eikyo.pro/api/campaigns/create', data: {
                token: rootState.token,
                domain: domain.domain,
                name: domain.name,
                config: JSON.stringify(state.templates[domain.template].config),
                content: state.templates[domain.template].content
              }, method: 'POST' })
                .then(resp => {
                    commit("DOMAINS_CREATED")
                    resolve(resp.data.payload.Table[0]['newID'])
                })
            })
          },
          EDIT_DOMAIN: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("DOMAINS_CREATING")
              axios({url: 'https://www.eikyo.pro/api/campaigns/edit', data: {
                token: rootState.token,
                domain: domain.domain,
                name: domain.name,
                domainID: domain.id,
              }, method: 'POST' })
                .then(resp => {
                    commit("DOMAINS_CREATED");
                    commit("widgets/DOMAIN_EDITED", domain, {root : true});
                    resolve(resp.data.payload)
                })
            })
          },
          SAVE_DOMAIN: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit;
              axios({url: 'https://www.eikyo.pro/api/campaigns/save', data: {
                token: rootState.token,
                domain: domain.id,
                content: domain.content,
                config: JSON.stringify(domain.config),
                enabled: (domain.enabled === true || domain.enabled === 1) ? 1 : 0,
              }, method: 'POST' })
                .then(resp => {
                    resolve(resp.data.payload)
                })
            })
          },
          DELETE_DOMAIN: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("DOMAINS_CREATING")
              axios({url: 'https://www.eikyo.pro/api/campaigns/delete', data: {
                token: rootState.token,
                domain: domain.id,
              }, method: 'POST' })
                .then(resp => {
                    commit("DOMAINS_CREATED");
                    resolve(resp.data.payload)
                })
            })
          }
     },
  }
  